module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "emit-plume--cover.34792feb.jpg";